import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {LayoutService} from "../../service/layout.service";
import {AuthService} from "../../../core/service/auth.service";
import {Router} from "@angular/router";
import {ProfileDto} from "../../../cross/user/types/user.types";
import {MessageHelper} from "../../../core/helper/message-helper";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {AppMessageService} from "../../../core/service/app-message.service";

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  items!: MenuItem[];
  logoutDialog: boolean = false;

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;
  userProfileDto?: ProfileDto;
  userProfilePhoto?: string | null;
  constructor(public layoutService: LayoutService,
              protected authService: AuthService,
              protected router: Router, protected userApiService: UserApiService,
              protected messageService: AppMessageService,) {}

  ngOnInit() {
    // load user profile
    this.getUserProfile();
  }
  protected getUserProfile() {
    this.userApiService.getProfile().subscribe((res: ProfileDto) => {
      this.userProfileDto = res;
      if (res.exUserPhotoDto) {
        this.userProfilePhoto = `data:${res.exUserPhotoDto.mimeType};base64,${res.exUserPhotoDto.dataBase64}`;
      }
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  handleLogoutDialog() {
    this.logoutDialog = true;
  }

  handleLogout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  onHideDialog() {
    this.logoutDialog = false
  }

}
